// // ResetPassword.js
// import React, { useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useResetPasswordMutation } from "../slices/authSlice";
// import Input from "../components/utilComponents/Input";
// import Button from "../components/utilComponents/Button";

// const ResetPassword = () => {
//   const { token } = useParams();
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [resetPassword] = useResetPasswordMutation();
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (password !== confirmPassword) {
//       setError("Passwords do not match");
//       return;
//     }
//     setLoading(true);
//     setError("");
//     setSuccess("");
//     try {
//       await resetPassword({ token, password }).unwrap();
//       setSuccess("Password reset successful");
//       navigate("/login");
//     } catch (error) {
//       setError("Error resetting password");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-agBg">
//       <div className="bg-white p-8 rounded-xl shadow-md w-[90vw] md:w-96">
//         {error && <p className="text-red-500 mb-4">{error}</p>}
//         {success && <p className="text-green-500 mb-4">{success}</p>}
//         <form onSubmit={handleSubmit}>
//           <Input
//             type="password"
//             placeholder="Enter new password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             isFullWidth
//           />
//           <Input
//             type="password"
//             placeholder="Confirm new password"
//             value={confirmPassword}
//             onChange={(e) => setConfirmPassword(e.target.value)}
//             isFullWidth
//           />
//           <Button
//             type="submit"
//             variant="primary"
//             isFullWidth
//             isActive={!loading}
//           >
//             {loading ? "Resetting..." : "Reset Password"}
//           </Button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ResetPassword;

// ResetPassword.js
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useResetPasswordMutation } from "../slices/authSlice";
import PasswordInput from "../components/utilComponents/PasswordInput";
import Button from "../components/utilComponents/Button";
import Success from "../components/message/Success";
import Error from "../components/message/Error";

const ResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [resetPassword] = useResetPasswordMutation();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      await resetPassword({ token, password }).unwrap();
      setSuccess("Password reset successful");
      setTimeout(() => navigate("/login"), 3000); // Redirect after success message
    } catch (error) {
      setError("Error resetting password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <div className="bg-white p-8 rounded-xl shadow-md w-[90vw] md:w-96">
        {error && <Error message={error} onClose={() => setError("")} />}
        {success && (
          <Success message={success} onClose={() => setSuccess("")} />
        )}
        <form onSubmit={handleSubmit}>
          <PasswordInput
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            isFullWidth
            showConditions={true}
            placeholder="Enter new password"
          />
          <PasswordInput
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            isFullWidth
            showConditions={false} // Hide conditions on the confirm password input
            placeholder="Confirm new password"
          />
          <Button
            type="submit"
            variant="primary"
            fullWidth={true}
            isActive={!loading}
            isLoading={loading}
          >
            Reset Password
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
